module.exports = __webpack_public_path__ + "static/media/19a-01-HOME_Variaciones-e-improvisaciones-2019-200x179cm-oleo-sobre-madera.8701a072.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/19a/19a-01-HOME_Variaciones-e-improvisaciones-2019-200x179cm-oleo-sobre-madera.jpg
// module id = 236
// module chunks = 0